import { Component } from 'react';
/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
export default class OptGroup extends Component {
}
OptGroup.__PRO_OPT_GROUP = true;
